<template>
  <nx-bform-group :label="requiredLabel(name)" v-bind="$attrs">
    <slot>
      <nx-bform-input
        :name="name"
        :rules="{ required, regex: /^[a-zA-Z0-9\_]*$/}"
        :value="$attrs.value"
        @input="$listeners.input"
      />
    </slot>
  </nx-bform-group>
</template>

<script>
import FormGroupMixin from "../form-group.mixin";

export default {
  mixins: [FormGroupMixin],
  computed: {
    name() {
      return this.label || this.$t("loginName");
    }
  }
};
</script>

<i18n src="@/locales/login.locale.json" />
